var createFocusTrap = require('focus-trap/dist/focus-trap');

var modalFocus = null;
var currentModal = null;

function showModal(modalElem, options) {
	let button = this;

	currentModal = modalElem
	currentModal.classList.add("active");
	currentModal.setAttribute("aria-hidden", "");
	

	if(options.modalContent) {
		let contentElement = document.getElementById(options.modalContent);

		if(contentElement) {
			currentModal.querySelector(".modal-content-area").innerHTML = contentElement.innerHTML;	
		} else {
			console.error("Missing modal content " + options.modalContent);
		}
	}


	modalFocus = createFocusTrap("#" + modalElem.id + " > div", {
		fallbackFocus: "#" + modalElem.id + " > div",
	 	onDeactivate: function() {
	        button.focus();
    	}
    });

    modalFocus.activate();
}

function onClicked(evt) {

	showModal(document.getElementById(this.dataset.showModal), this.dataset);

	evt.preventDefault();
}

function closeModal(evt) {
	if(evt.type == "click") {
		if(evt.target && !(evt.target.classList.contains('close-modal') || evt.target.parentElement.classList.contains('close-modal') ) ) {
			return;
		}
	}

	if(currentModal) {
		currentModal.classList.remove("active");
		currentModal.setAttribute('aria-hidden', 'true');
		if (currentModal.querySelector(".modal-content-area") !== null)
			currentModal.querySelector(".modal-content-area").innerHTML = "";
		modalFocus.deactivate();					
	}

	currentModal = null;
}

module.exports = {
	init() {
		var modalButtons = document.querySelectorAll("[data-show-modal]");

		Array.from(modalButtons).forEach(button => {
			button.addEventListener("click", onClicked);
		});

		var closeButtons = document.querySelectorAll(".close-modal");

		Array.from(closeButtons).forEach( (button) => {
			button.addEventListener("click", closeModal);
		});

		document.addEventListener('keyup', function(evt) {
		    evt = evt || window.event;
		    if (evt.keyCode == 27) {
		    	closeModal( evt );
		    }
		});

		var showOnLoad = document.querySelectorAll("[data-modal-show-on-load]");

		Array.from(showOnLoad).forEach( (modal) => {
			showModal(modal, {} );
		});

	}
}